import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../modules/access-system/services/auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AppInitService {

    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    /**
     * Inicializa a aplicação verificando se deve mostrar login ou dashboard
     */
    initializeApp(): void {
        // Se o login não estiver habilitado, redireciona diretamente para dashboard
        if (!this.authService.isLoginEnabled) {
            this.router.navigate(['/dashboard']);
            return;
        }

        // Se o login estiver habilitado, verifica se está autenticado
        if (this.authService.isAuthenticated) {
            // Se já estiver logado, redireciona para dashboard
            this.router.navigate(['/dashboard']);
        } else {
            // Se não estiver logado, redireciona para login
            this.router.navigate(['/login']);
        }
    }
}